import { lazy } from "react";
import { setStudioView } from "../workspace/studio-views";
import type { ProjectPlanProps } from "./ProjectPlan";
const ProjectPlan = lazy(() => import("./ProjectPlan").then(module => ({ default: module.ProjectPlan })));

export function mountProjectPlan(slot: HTMLElement, props: ProjectPlanProps) {
  setStudioView("project-plan", `project-plan:${props.project.id}`, <ProjectPlan key={props.project.id} {...props} />);
}
